//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mobile, PC } from "../../../media/MediaQuery";

//css
import styled from "styled-components";

// Import Swiper styles
import "swiper/css";

// responsive
import { M, T } from "../../../utils/MT";
// img
import ProductJpg from "../../../assets/img/main/product_bg.jpg";
import Product from "../../../assets/img/main/product.png";
import ProductBg1 from "../../../assets/img/main/product_bg1.png";
import ProductBg2 from "../../../assets/img/main/product_bg2.png";
import ProductBg3 from "../../../assets/img/main/product_bg3.png";
import MainBanner1 from "../../../assets/img/main/main_banner1.jpg";
import MainBanner2 from "../../../assets/img/main/main_banner2.jpg";
import NewProduct1 from "../../../assets/img/main/new_product1.png";
import NewProduct2 from "../../../assets/img/main/new_product2.png";

export default function Main() {
    //페이지 이동
    const navigate = useNavigate();
    const goBuynow = () => {
        navigate(`/product/detail/1`);
    };

    // 스크롤 아이콘 누르면 다음섹션으로 이동.
    const myRef = useRef(null);
    const executeScroll = () => myRef.current.scrollIntoView();

    // 상품 4개 데이터
    const ProductListData = [
        {
            name: "3D Printers",
            content: (
                <>
                    프로토타입 제작에 최적화된 전문가용&nbsp;
                    <PcBr />
                    3D프린터로
                    <MobileBr /> 모든 기업 환경에서 사용하기 적합한
                    <br />
                    FFF(Fused Filament Fabrication)프린터로서
                    <br />
                    산업용 수준의 프로토타입을 제작할 수 있습니다.
                </>
            ),
            btn: "Buy Now",
            bg: ProductBg1,
            onClickEvent: goBuynow,
        },
        {
            name: "Filaments",
            content: (
                <>
                    fabWeaver의 필라멘트는 최상의 성능과 출력
                    <br />
                    품질을 보장하며 언제나 일관성 있는
                    <br />
                    출력물을 제공합니다.
                </>
            ),
            btn: "Buy Now",
            bg: ProductBg2,
            onClickEvent: goBuynow,
        },
        {
            name: "Supplies",
            btn: "View +",
            bg: ProductBg3,
            onClickEvent: goBuynow,
        },
        {
            name: "As Part",
            btn: "View +",
            bg: ProductBg3,
            onClickEvent: goBuynow,
        },
    ];

    // new arrival 데이터
    const arrivalData = [
        {
            img: NewProduct1,
            name: "3D PRT",
        },
        {
            img: NewProduct2,
            name: "Filaments",
        },
        {
            img: NewProduct2,
            name: "Option1",
        },
    ];

    return (
        <Wrap>
            {/* 첫번째 배너 */}
            <ProductBannerWrap ref={myRef}>
                <BannerContent>
                    <BannerTextBox>
                        <BannerTitle>type A530</BannerTitle>
                        <BannerSubText>
                            type A530은 간단한 PoC(Proof of Concept)에서 부터 <br />
                            작동 부품의 설계 검증, 성능 테스트 및 제품 모델 출력에 이르기 까지
                            <br />
                            최고 품질의 전문적인 3D 프로토타입을 제공하기 위해 설계된 플랫폼입니다.
                            <br />
                            <b>누구나, 손쉽게 산업용 수준의 3D프린터를 경험할 수 있습니다.</b>
                        </BannerSubText>
                        <BannerBtn onClick={goBuynow}>Buy now</BannerBtn>
                    </BannerTextBox>

                    <BannerProduct>
                        <img src={Product} alt="상품" />
                    </BannerProduct>
                </BannerContent>
            </ProductBannerWrap>

            {/* 4개짜리 상품 배너 */}
            <PC>
                <ProductListWrap>
                    {ProductListData.map((item, index) => {
                        return (
                            <ProductList key={index}>
                                <ProductBg src={item.bg} alt={item.name} />
                                <ProductTextBox>
                                    <ProductBigText>{item.name}</ProductBigText>
                                    <ProductSubText>{item.content}</ProductSubText>
                                    <ProductListBtn onClick={item.onClickEvent}>{item.btn}</ProductListBtn>
                                </ProductTextBox>
                            </ProductList>
                        );
                    })}
                </ProductListWrap>
            </PC>
            <Mobile>
                <ProductListWrap>
                    <Swiper slidesPerView={1.1} spaceBetween={20} centeredSlides={true} className="main_Swiper">
                        {ProductListData.map((item, index) => {
                            return (
                                <SwiperSlide key={"main_Swiper" + index}>
                                    <ProductList key={index}>
                                        <ProductBg src={item.bg} alt={item.name} />
                                        <ProductTextBox>
                                            <ProductBigText>{item.name}</ProductBigText>
                                            <ProductSubText>{item.content}</ProductSubText>
                                            <ProductListBtn onClick={item.onClickEvent}>{item.btn}</ProductListBtn>
                                        </ProductTextBox>
                                    </ProductList>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </ProductListWrap>
            </Mobile>

            {/* 중간 배너 */}
            <ImgBannerWrap>
                <BannerImg>
                    <img src={MainBanner1} alt="메인배너" />
                </BannerImg>
                <ImgTextBox>
                    <BannerText>Industrial 3D Printing for Flexible Manufacturing</BannerText>
                </ImgTextBox>
            </ImgBannerWrap>

            {/* new arrival 상품 부분 */}
            <PC>
                <NewProductWrap>
                    <NewProductTitle>New arrival</NewProductTitle>

                    <NewListWrap>
                        {arrivalData.map((item, index) => {
                            return (
                                <NewProductList key={index}>
                                    <NewProductImg>
                                        <img src={item.img} alt="상품" />
                                    </NewProductImg>
                                    <NewProductName>{item.name}</NewProductName>
                                </NewProductList>
                            );
                        })}
                    </NewListWrap>
                </NewProductWrap>
            </PC>

            <Mobile>
                <NewProductWrap>
                    <NewProductTitle>New arrival</NewProductTitle>

                    <NewListWrap>
                        <Swiper slidesPerView={2.2} spaceBetween={16} className="newItem_Swiper">
                            {arrivalData.map((item, index) => {
                                return (
                                    <SwiperSlide key={"newItem_Swiper" + index}>
                                        <NewProductList key={index}>
                                            <NewProductImg>
                                                <img src={item.img} alt="상품" />
                                            </NewProductImg>
                                            <NewProductName>{item.name}</NewProductName>
                                        </NewProductList>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </NewListWrap>
                </NewProductWrap>
            </Mobile>

            {/* 마지막 배너 */}
            <LastBannerWrap>
                <LastBannerImg>
                    <img src={MainBanner2} alt="메인배너" />
                </LastBannerImg>
                <LastTextBox>
                    <LastText>
                        fabWeaver 온라인 스토어에서
                        <MobileBr /> 구매 관련 도움이 필요하다면?
                    </LastText>
                    <LastTextBtn>Contact us</LastTextBtn>
                </LastTextBox>
            </LastBannerWrap>
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;
`;
const ProductBannerWrap = styled.section`
    position: relative;
    width: 100%;

    background: url(${ProductJpg}) no-repeat center center / cover;
`;

const BannerContent = styled.div`
    position: relative;
    width: calc(100vw * (1072 / 1920));
    min-height: calc(100vw * (625 / 1920));
    margin: 0 auto;

    padding: calc(100vw * (100 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1072 / 1300));
        min-height: calc(100vw * (625 / 1300));

        padding: calc(100vw * (100 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        min-height: ${M(347)};

        padding: ${M(40)} 0;
    }
`;

const MainTextBox = styled.div`
    position: relative;

    margin: auto;
`;
const BannerTextBox = styled(MainTextBox)`
    position: relative;
    margin-left: calc(100vw * (115 / 1920));
    /* margin: calc(100vw * (143/ 1920)) auto calc(100vw * (234/ 1920)); */
    z-index: 1;

    @media screen and (max-width: 1300px) {
        margin-left: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-left: 0;
        padding: ${M(40)} 0;
    }
`;

const BannerTitle = styled.p`
    font: calc(100vw * (40 / 1920)) "Pop-L";

    color: #fff;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (40 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;
const BannerSubText = styled.p`
    font: calc(100vw * (13 / 1920)) "Noto-R";
    white-space: pre-line;

    margin-top: calc(100vw * (25 / 1920));

    color: #aaaaaa;

    & b {
        display: inline-block;
        font-family: "Noto-B";
        color: #fff;
        margin-top: calc(100vw * (8 / 1920));
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));

        & b {
            margin-top: calc(100vw * (8 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(10)};

        font-size: ${M(11)};

        & b {
            margin-top: ${M(8)};
        }
    }
`;
const BannerBtn = styled.p`
    display: inline-block;
    font-family: "Pop-R";

    margin-top: calc(100vw * (45 / 1920));
    padding: calc(100vw * (8 / 1920)) calc(100vw * (24 / 1920));

    font-size: calc(100vw * (15 / 1920));
    border: 1px solid #fff;
    border-radius: 55px;
    color: #fff;

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (45 / 1300));
        padding: calc(100vw * (8 / 1300)) calc(100vw * (24 / 1300));

        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(20)};
        padding: ${M(8)} ${M(23)};

        font-size: ${M(13)};
    }
`;
const BannerProduct = styled.div`
    position: absolute;
    right: 0;
    bottom: 0;

    width: calc(100vw * (560 / 1920));
    height: calc(100vw * (560 / 1920));

    z-index: 0;

    width: calc(100vw * (560 / 1920));
    height: calc(100vw * (560 / 1920));

    & img {
        width: 100%;
        height: 100%;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (560 / 1300));
        height: calc(100vw * (560 / 1300));

        width: calc(100vw * (560 / 1300));
        height: calc(100vw * (560 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(211)};
        height: ${M(211)};
    }
`;

// 세번째 섹션
const ProductListWrap = styled.section`
    display: flex;
    flex-wrap: wrap;

    width: calc(100vw * (1060 / 1920));
    margin: calc(100vw * (100 / 1920)) auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));
        margin: calc(100vw * (100 / 1300)) auto;
    }

    @media screen and (max-width: 900px) {
        width: 100%;

        margin: ${M(40)} 0 ${M(70)};
        /* 
        & .main_Swiper {
            padding-left: ${M(7)};
        }
        } */
    }
`;
const ProductList = styled.div`
    position: relative;
    display: inline-flex;
    justify-content: flex-end;
    align-items: center;

    width: calc(100vw * (510 / 1920));
    min-height: calc(100vw * (400 / 1920));
    height: 100%;
    padding: calc(100vw * (30 / 1920));

    border-radius: 30px;
    box-shadow: 0 0 6px 0 rgba(121, 121, 121, 0.16);
    border: solid 1px #eee;
    overflow: hidden;

    background: #fafafa;

    z-index: 0;

    &:nth-child(n + 3) {
        margin-top: calc(100vw * (40 / 1920));
    }

    &:nth-child(odd) {
        margin-right: calc(100vw * (40 / 1920));
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (510 / 1300));
        min-height: calc(100vw * (400 / 1300));
        padding: calc(100vw * (30 / 1300));

        &:nth-child(n + 3) {
            margin-top: calc(100vw * (40 / 1300));
        }

        &:nth-child(odd) {
            margin-right: calc(100vw * (40 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        min-height: ${M(250)};
        padding: ${M(30)} ${M(15)};

        &:nth-child(n + 3) {
            margin-top: 0;
        }

        &:nth-child(odd) {
            margin-right: 0;
        }
    }
`;
const ProductBg = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    z-index: -1;
`;
const ProductTextBox = styled.div`
    text-align: right;
`;
const ProductBigText = styled.h2`
    font-size: calc(100vw * (50 / 1920));
    font-family: "Pop-M";

    margin-bottom: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (50 / 1300));

        margin-bottom: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(25)};

        margin-bottom: ${M(3)};
    }
`;
const ProductSubText = styled.p`
    font-family: "Noto-R";
    width: calc(100vw * (270 / 1920));
    font-size: calc(100vw * (13 / 1920));
    line-height: 1.5;
    color: #aaaaaa;
    word-break: keep-all;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (270 / 1300));
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(230)};
        font-size: ${M(11)};
    }
`;
const ProductListBtn = styled(BannerBtn)`
    border: 1px solid var(--main-color);
    color: var(--main-color);
`;

// 3d 글씨 배너
const ImgBannerWrap = styled.section`
    position: relative;
    overflow: hidden;

    min-height: calc(100vw * (474 / 1920));
    padding: calc(100vw * (220 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        min-height: calc(100vw * (474 / 1300));
        padding: calc(100vw * (220 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        min-height: ${M(150)};
        padding: ${M(66)} 0;
    }
`;
const BannerImg = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    & img {
        display: block;
        width: 100%;
        height: 100%;
    }
`;
const ImgTextBox = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: calc(100vw * (1060 / 1920));
    margin: 0 auto;

    z-index: 1;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
    }
`;
const BannerText = styled.p`
    font-family: "Pop-M";
    font-size: calc(100vw * (25 / 1920));
    text-align: center;

    color: #fff;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(12)};
    }
`;

// New arrival 상품 부분
const NewProductWrap = styled.section`
    width: calc(100vw * (1060 / 1920));
    margin: calc(100vw * (100 / 1920)) auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));
        margin: calc(100vw * (100 / 1300)) auto;
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        margin: ${M(60)} auto ${M(120)};
    }
`;
const NewProductTitle = styled.h2`
    font: calc(100vw * (40 / 1920)) "Pop-M";

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (40 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};
        padding-left: ${M(25)};
    }
`;
const NewListWrap = styled.ul`
    display: flex;

    margin-top: calc(100vw * (35 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (35 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(20)};

        & .newItem_Swiper {
            padding-left: ${M(25)};
        }
    }
`;
const NewProductList = styled.li`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;

    width: calc(100vw * (331 / 1920));
    height: calc(100vw * (331 / 1920));
    padding: calc(100vw * (30 / 1920)) calc(100vw * (50 / 1920));
    margin-right: calc(100vw * (33 / 1920));

    border-radius: 30px;
    box-shadow: 0 0 6px 0 rgba(121, 121, 121, 0.16);
    border: solid 1px #eee;
    background-color: #fff;

    overflow: hidden;

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (331 / 1300));
        height: calc(100vw * (331 / 1300));
        padding: calc(100vw * (30 / 1300)) calc(100vw * (50 / 1300));
        margin-right: calc(100vw * (33 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        height: ${M(161)};
        padding: ${M(18)} ${M(33)} ${M(14)};
        margin-right: 0;

        border-radius: 15px;
    }
`;
const NewProductImg = styled.div`
    flex-shrink: 0;
    display: flex;
    width: calc(100vw * (214 / 1920));
    height: calc(100vw * (230 / 1920));

    margin: 0 auto;

    & img {
        width: 100%;
        height: auto;

        margin: auto;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (214 / 1300));
        height: calc(100vw * (230 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(93)};
        height: ${M(99)};
    }
`;
const NewProductName = styled.p`
    margin-top: calc(100vw * (20 / 1920));

    text-align: center;
    font-family: "Pop-M";
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));

        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(12)};
        margin-top: ${M(11)};
    }
`;

// 마지막 배너
const LastBannerWrap = styled(ImgBannerWrap)`
    width: 100%;
    min-height: calc(100vw * (350 / 1920));

    padding: calc(100vw * (125 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        min-height: calc(100vw * (350 / 1300));

        padding: calc(100vw * (125 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        min-height: ${M(150)};
        padding: ${M(30)} 0;
    }
`;
const LastBannerImg = styled(BannerImg)``;

const LastTextBox = styled(ImgTextBox)`
    text-align: center;
`;
const LastText = styled(BannerText)`
    font-family: "Pop-M";
    font-size: calc(100vw * (25 / 1920));
    color: #fff;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;
const LastTextBtn = styled.p`
    display: inline-block;
    font-family: "Pop-R";

    margin-top: calc(100vw * (25 / 1920));
    padding: calc(100vw * (8 / 1920)) calc(100vw * (16 / 1920));

    font-size: calc(100vw * (15 / 1920));
    border: 1px solid #fff;
    border-radius: 55px;
    color: #fff;

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (25 / 1300));
        padding: calc(100vw * (8 / 1300)) calc(100vw * (16 / 1300));

        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(16)};
        padding: ${M(9)} ${M(22)};

        font-size: ${M(13)};
    }
`;

const PcBr = styled.br`
    display: block;

    @media screen and (max-width: 900px) {
        display: none;
    }
`;
const MobileBr = styled.br`
    display: none;

    @media screen and (max-width: 900px) {
        display: block;
    }
`;
